import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, AlertCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#050914] border-t border-[#D4AF37]/[0.22] shadow-[0_-14px_42px_rgba(0,0,0,0.38)]">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/downsizegta-emblem.png"
                alt="DownsizeGTA"
                className="h-12 w-auto opacity-80"
              />
              <span className="font-playfair text-[#D4AF37]/90 text-lg font-medium tracking-[0.02em]">DownsizeGTA</span>
            </div>
            <p className="text-white/80 text-sm leading-relaxed max-w-md mb-5">
              DAS™ Downsizing Advisory System<br />
              Private Advisory by Olivia Williams Realty<br />
              DownsizeGTA.com
            </p>
            <div className="flex items-center gap-2 text-white/80 text-xs">
              <MapPin size={12} />
              <span>Greater Toronto Area, Ontario</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white/95 font-semibold text-sm mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/calculator" className="text-white/80 hover:text-[#D4AF37] text-sm transition-colors">
                  Downsizing Wealth Analysis
                </Link>
              </li>
              <li>
                <Link to="/ip-notice" className="text-white/80 hover:text-[#D4AF37] text-sm transition-colors">
                  Intellectual Property Notice
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-white/80 hover:text-[#D4AF37] text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="text-white/80 hover:text-[#D4AF37] text-sm transition-colors">
                  Terms of Use
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white/95 font-semibold text-sm mb-4">Contact</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="tel:416-302-6360" className="flex items-center gap-2 text-white/80 hover:text-[#D4AF37] text-sm transition-colors">
                  <Phone size={12} />
                  416-302-6360
                </a>
              </li>
              <li>
                <a href="mailto:olivia@downsizegta.com" className="flex items-center gap-2 text-white/80 hover:text-[#D4AF37] text-sm transition-colors">
                  <Mail size={12} />
                  Email Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-white/[0.09] mt-10 pt-8">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 mb-3">
              <AlertCircle size={13} className="text-[#D4AF37]/80 flex-shrink-0" />
              <span className="text-[#D4AF37]/90 text-[10px] font-semibold tracking-[0.15em] uppercase">Important Disclaimer</span>
            </div>
            <p className="text-white/80 text-xs leading-[2] max-w-2xl">
              This analysis is provided for informational and educational purposes only and does not constitute financial, investment, legal, or real estate advice.
              All estimates are based on user inputs and current market assumptions, which may change.
              You should consult qualified professionals before making any real estate or financial decisions.
            </p>
          </div>
        </div>

        {/* DAS IP Notice */}
        <div className="border-t border-white/[0.09] mt-8 pt-6">
          <p className="text-white/80 text-[13px] leading-relaxed max-w-4xl">
            <span className="text-[#D4AF37] font-medium">DAS™ Downsizing Advisory System</span> is a proprietary platform of Olivia Williams Realty. Copyright in DAS™ Downsizing Advisory System is registered in Canada under Registration No. 1244327. © DAS™ Downsizing Advisory System. All rights reserved. © {new Date().getFullYear()} Olivia Williams Realty. All rights reserved. The DAS™ name, logos, branding, trade dress, interface, page design, reports, calculators, workflows, content, documentation, and software code are proprietary to Olivia Williams Realty and protected by registered copyright and other applicable proprietary rights. Unauthorized copying, reproduction, scraping, reverse engineering, distribution, modification, republication, or commercial use is strictly prohibited without prior written consent.{' '}
            <Link to="/ip-notice" className="text-[#D4AF37] hover:text-[#e8c84b] underline underline-offset-2 transition-colors font-medium">
              Intellectual Property Notice
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
